export default {
	name: 'school-setup',
	path: '/school-setup',
	meta: {
		title: '设置中心'
	},
	redirect: '/school-setup/system-setup',
	children: [
		{
			name: 'setup-system-setup',
			path: 'system-setup',
			fullPath: '/school-setup/system-setup',
			meta: {
				// title: '系统设置'
			},
			component: () =>
				import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/system-setup')
		},
		{
			name: 'setup-users',
			path: 'users',
			fullPath: '/school-setup/users',
			meta: {
				title: '用户管理'
			},
			redirect: '/school-setup/users/staff',
			component: () =>
				import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users'),
			children: [
				{
					name: 'users-staff',
					path: 'staff',
					fullPath: '/school-setup/users/staff',
					meta: {
						// title: '职工管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users/staff')
				},
				{
					name: 'users-admin',
					path: 'admin',
					fullPath: '/school-setup/users/admin',
					meta: {
						// title: '系统管理员'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users/admin')
				},
				{
					name: 'users-operator',
					path: 'operator',
					fullPath: '/school-setup/users/operator',
					meta: {
						// title: '运营人员'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users/operator')
				},
				{
					name: 'users-agent',
					path: 'agent',
					fullPath: '/school-setup/users/agent',
					meta: {
						// title: '代理商'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users/agent')
				},
				{
					name: 'users-school',
					path: 'school',
					fullPath: '/school-setup/users/school',
					meta: {
						// title: '学校管理员'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users/school')
				},
				{
					name: 'users-add',
					path: 'add',
					fullPath: '/school-setup/users/add',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users/add')
				},
				{
					name: 'users-moral',
					path: 'moral',
					fullPath: '/school-setup/users/moral',
					meta: {
						// title: '德育'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/users/moral')
				}
			]
		},
		{
			name: 'setup-roles',
			path: 'roles',
			fullPath: 'school-setup/roles',
			meta: {
				title: '角色管理'
			},
			redirect: '/school-setup/roles/search',
			component: () =>
				import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/roles'),
			children: [
				{
					name: 'roles-search',
					path: 'search',
					fullPath: '/school-setup/roles/search',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/roles/search')
				},
				{
					name: 'roles-add',
					path: 'add',
					fullPath: '/school-setup/roles/add',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/roles/add')
				}
			]
		},
		{
			name: 'setup-permissions',
			path: '/school-setup/permissions',
			fullPath: 'permissions',
			meta: {
				title: '权限管理'
			},
			redirect: '/school-setup/permissions/search',
			component: () =>
				import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/roles'),
			children: [
				{
					name: 'permissions-search',
					path: 'search',
					fullPath: '/school-setup/permissions/search',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/permissions/search')
				},
				{
					name: 'permissions-add',
					path: 'add',
					fullPath: '/school-setup/permissions/add',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/permissions/add')
				},
				{
					name: 'permissions-lack',
					path: 'lack',
					fullPath: '/school-setup/permissions/lack',
					meta: {
						// title: '权限缺失'
					},
					component: () =>
						import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/permissions/lack')
				}
			]
		},
		{
			name: 'oem-manage',
			path: 'oem',
			fullPath: '/school-setup/oem',
			meta: {
				// title: 'OEM管理'
			},
			component: () =>
				import(/* webpackChunkName: "school-setup" */ '@/views/school-setup/oem')
		},
		{
			name: 'applets-management',
			path: '/applets-management',
			meta: {
				title: '小程序管理'
			},
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/school-setup/applets-management')
		}
	]
};
